import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ProductAllowanceTableRow from "../../../components/Settings/productAllowanceTableRow/ProductAllowanceTableRow";
import Axios from "axios-https-proxy-fix";
import { Dropdown } from "semantic-ui-react";
import { toast } from "react-toastify";
import InputMask from "react-input-mask";
import "./pricing.scss";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import translator, { translate_switch } from "../../../utils/translator";

export class Pricing extends Component {
	static propTypes = {
		prop: PropTypes
	};

	state = {
		searchTimeout: null,
		shipTo: "",
		listOfAccounts: null,
		displayShipToAndWarehouseInputFields: false,
		displayListOfProductAllowanceForThisAccount: false,
		listOfShipTos: [],
		listOfProducts: [],
		selectedAccountId: null,
		productAllowanceAmount: "",
		listOfProductAllowance: [],
		searchThisWarehouseNumber: "",
		selectedTrendProductId: "",
	};

	inputNumberBlockedChars = ['e', 'E', '+', '-'];

	toast_config = {
		position: "bottom-center",
		autoClose: true,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true
	};

	selectedProduct = async (event, { value, text }) => {
		this.setState({ selectedTrendProductId: value });
	};

	getProductAllowanceForSelectedAccount = async event => {
		let getProductAllowanceAPIUrl = this.props.APIUrl + "/settings/product-allowance";
		let data = {
			pricing_account_id: this.state.selectedAccountId,
			ship_to: this.state.shipTo,
			warehouse: this.state.searchThisWarehouseNumber,
			language: this.props.selected_language
		};
		let getProductAllowanceAPIResponse = await Axios.post(getProductAllowanceAPIUrl, data);

		if(!!getProductAllowanceAPIResponse.data.error) {
			this.setState({
				listOfProductAllowance: [],
				displayListOfProductAllowanceForThisAccount: false
			});
			return toast.error(getProductAllowanceAPIResponse.data.error, this.toast_config);
		}

		let productsAllowances =
			getProductAllowanceAPIResponse.data.product_allowances_for_selected_account;

		if (productsAllowances) {
			let storeProductAllowances = await productsAllowances.map((productAllowance, index) => (
				<ProductAllowanceTableRow
					trendProductId={productAllowance.product_sku}
					productDescription={({
						en: productAllowance.title,
						fr: productAllowance.title_fr || productAllowance.title,
					})}
					productAllowanceAmount={productAllowance.amount}
					productAllowanceId={productAllowance.id}
					index={index}
					toastConfig={this.toast_config}
				/>
			));
			this.setState({
				listOfProductAllowance: storeProductAllowances,
				displayListOfProductAllowanceForThisAccount: true
			});
		}
	};

	debounceProductSearch = event => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			searchTimeout: window.setTimeout(this.reSearchForProductsInformation, 500, event.target.value)
		});
	};

	reSearchForProductsInformation = async query => {
		const response = await Axios.post(
			this.props.APIUrl + "/settings/product-information",
			{ query, language: this.props.selected_language }
		);
		const products = response.data.products.map((product) => (
			{
				value: product.sku,
				text: product.sku + " - " + translate_switch(product.name),
			}
		));
		this.setState({ listOfProducts: products });
	};

	// Adding product allowances using the new table Aman created
	AddNewProductAllowance = async () => {
		if(this.state.selectedTrendProductId === "" || this.state.productAllowanceAmount === "") {
			return toast.error(translator('Misc', 'allowance_sku_price_error'), this.toast_config);
		}
		let addNewProductAllowanceAPIUrl = this.props.APIUrl + "/settings/product-allowance/add";
		let data = {
			edited_by: localStorage.getItem("trendId"),
			pricing_account_id: this.state.selectedAccountId,
			ship_to: this.state.shipTo,
			warehouseNumber: this.state.searchThisWarehouseNumber,
			product_sku: this.state.selectedTrendProductId,
			// we get the title using the trend id in the backend. We will use the trend description for the title when we get it back from get it
			amount: this.state.productAllowanceAmount,
			language: this.props.selected_language
		};
		let addNewProductAllowanceAPIResponse = await Axios.post(
			addNewProductAllowanceAPIUrl,
			data
		);

		if(!!addNewProductAllowanceAPIResponse.data.error) {
			return toast.error(addNewProductAllowanceAPIResponse.data.error, this.toast_config);
		}

		await this.getProductAllowanceForSelectedAccount();
		return toast.success(addNewProductAllowanceAPIResponse.data.message, this.toast_config);
	};

	findAccountPricing = async () => {
		this.getProductAllowanceForSelectedAccount();
	};

	getAccounts = async query => {
		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getAccountInformationAPIUrl = this.props.APIUrl + "/settings/account-information";

		const data = {
			token,
			trendId,
			searchTerm: query,
			warehourse: this.state.searchThisWarehouseNumber
		};

		const getAccountInformationApiResponse = await Axios.post(
			getAccountInformationAPIUrl,
			data
		);
		let listOfAccountsFromTrend =
			getAccountInformationApiResponse.data.getAccountInformationTrendResponse;
		const listOfAccounts = [];
		if (Array.isArray(listOfAccountsFromTrend)) {
			for (let i = 0; i < listOfAccountsFromTrend.length; i++) {
				let formatDataForInputDropDown = {
					text: listOfAccountsFromTrend[i].Name 
					+ ' | ' + listOfAccountsFromTrend[i].CustomerNumber,
					value: listOfAccountsFromTrend[i].CustomerNumber
				};

				listOfAccounts.push(formatDataForInputDropDown);
			}
			this.setState({ listOfAccounts: listOfAccounts });
		} else if (listOfAccountsFromTrend) {
			let formatDataForInputDropDown = {
				text: listOfAccountsFromTrend.Name,
				value: listOfAccountsFromTrend.CustomerNumber
			};
			listOfAccounts.push(formatDataForInputDropDown);
			this.setState({ listOfAccounts: listOfAccounts });
		} else {
			this.setState({ listOfAccounts: [] });
		}
	};

	searchAccounts = query => {
		window.clearTimeout(this.state.searchTimeout);
		this.setState({
			searchTimeout: window.setTimeout(this.getAccounts, 500, query)
		});
	};

	getShipTosForThisAccountId = async eventTargetValue => {
		if (eventTargetValue) {
			// we also need to get the account name to update the database
			let selectedAccountIndex = this.state.listOfAccounts.findIndex(
				account => account.value === eventTargetValue
			);

			await this.setState({
				selectedAccountId: eventTargetValue,
				shipTo: "",
				selectedAccountName: this.state.listOfAccounts[selectedAccountIndex].text
			}); // THIS RIGHT HERE PROVES THAT YOU SHOULD JUST USE AWAIT IN EVERY FUNCTION TO MAKE THE CODE SYNCHRNOUS. AWAIT MAKES THE FUNCTION A PROMISE. If you remove await from this.setState() it will not work the way you want it to. try and see for your self. Also, ignore your code editor message telling you await is uneccessary here. VS Code is dumb and lying to you.
		}
		let trendId = localStorage.getItem("trendId");
		let token = localStorage.getItem("token");

		const getShipToAPIUrl = this.props.APIUrl + "/projects/fetch-ship-to";

		const data = {
			token,
			trendId,
			projectAccountId: this.state.selectedAccountId,
			warehouse: this.state.searchThisWarehouseNumber
		};

		const getShipToAPIResponse = await Axios.post(getShipToAPIUrl, data);
		let listOfShipTosFromTrend = getShipToAPIResponse.data.listOfShipTosFromTrend;
		const listOfShipTos = [];

		// The reason we have an else statement here is because it crashes when you loop through a non array
		// so the else statement does not have a for loop.
		if (Array.isArray(listOfShipTosFromTrend)) {
			for (let i = 0; i < listOfShipTosFromTrend.length; i++) {
				let formatDataForDropDown = {
					text:
						listOfShipTosFromTrend[i].ShipTo +
						" | " +
						listOfShipTosFromTrend[i].CustomerNumber +
						" | " +
						listOfShipTosFromTrend[i].Name,
					value: listOfShipTosFromTrend[i].ShipTo
				};

				listOfShipTos.push(formatDataForDropDown);
			}
		} else if (listOfShipTosFromTrend === undefined) {
			// DO NOTHING. I know this seems sloppy but I mean it really isn't a big deal and not worth my time to find a logical way for ONLY and if and else
			// this means there are no ship tos for this account id. The reason i have this is because i don't want to the program to crash saying something like .ShipTo is not a property.
		} else {
			let formatDataForDropDown = {
				text: listOfShipTosFromTrend.ShipTo + " | " + listOfShipTosFromTrend.CustomerNumber,
				value: listOfShipTosFromTrend.ShipTo
			};

			listOfShipTos.push(formatDataForDropDown);
		}
		await this.setState({
			listOfShipTos: listOfShipTos,
			displayShipToAndWarehouseInputFields: true
		});
	};

	checkIfBlockedChar = event => {
		if(this.inputNumberBlockedChars.includes(event.key)) {
			event.preventDefault();
		}
	}

	render() {
		let productAllowances = this.state.listOfProductAllowance;
		let main = (
			<>
				<div class="card user-profile-card">
					<div class="card-body">
						<form>
							<div class="form-group">
								<label>{translator("Misc", "account_label")}</label>
								<Dropdown
									placeholder={translator("Misc", "select_label")}
									fluid
									search={(options, query) => options}
									selection
									options={this.state.listOfAccounts}
									onChange={(event, { value }) =>
										this.getShipTosForThisAccountId(value)
									}
									onSearchChange={(e, d) => {
										this.searchAccounts(d.searchQuery);
									}}
									value={this.state.accountId}
									noResultsMessage={translator("Misc", "no_results_found")}
								/>
							</div>
							{this.state.displayShipToAndWarehouseInputFields ? (
								<React.Fragment>
									<div class="form-group">
										<label>{translator("Misc", "ship_to_label")}</label>
										<Dropdown
											placeholder={
												this.state.listOfShipTos.length > 0
													? translator("Misc", "choose_ship_to_btn")
													: translator("Misc", "no_ship_to_with_account")
											}
											fluid
											selection
											options={this.state.listOfShipTos}
											onChange={(event, { value }) =>
												this.setState({ shipTo: value })
											}
											value={this.state.shipTo}
											noResultsMessage={translator("Misc", "no_results_found")}
										/>
									</div>
									<div class="form-group">
										<label>{translator("Admin Pricing", "warehouse_label")}</label>
										<InputMask
											mask="****" // Need 4 chars total & allow for letters
											maskChar=""
											value={this.state.searchThisWarehouseNumber}
											class="form-control settings-form"
											onChange={event => this.setState({ searchThisWarehouseNumber: event.target.value })}
										/>
									</div>
									<button
										onClick={this.findAccountPricing}
										type="button"
										class="btn btn-primary"
									>
										{translator("Admin Pricing", "find_info_label")}
									</button>
								</React.Fragment>
							) : null}
						</form>
					</div>
				</div>
				{this.state.displayListOfProductAllowanceForThisAccount ? (
					<div class="card user-profile-card">
						<div class="card-body">
							<div class="form-group">
								<label>{translator("Admin Pricing", "search_product_label")}</label>
								<Dropdown
									placeholder={translator("Admin Pricing", "product_label")}
									fluid
									className="test"
									selection
									search={(options, query) => options}
									options={this.state.listOfProducts}
									onSearchChange={this.debounceProductSearch}
									onChange={this.selectedProduct}
									noResultsMessage={translator("Misc", "no_results_found")}
								/>
								<label>{translator("Admin Pricing", "amount_label")}</label>
								<input
									type="number"
									class="form-control settings-form"
									onKeyDown={event => this.checkIfBlockedChar(event)}
									onChange={event =>
										this.setState({
											productAllowanceAmount: event.target.value
										})
									}
									value={this.state.productAllowanceAmount}
								/>
								<button
									onClick={this.AddNewProductAllowance}
									type="button"
									class="btn btn-primary"
								>
									{translator("Admin Pricing", "add_new_btn")}
								</button>
								<table class="table search-results-table edit-pricing-table">
									<tbody>
										{productAllowances.map(
											productAllowance => productAllowance
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				) : null}
			</>
		);
		return <SettingsWrapper header={translator("Admin Pricing", "page_title")} main={main} />;
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Pricing);
